document.addEventListener('DOMContentLoaded', function () {
    // ✅ Define main product and add-ons
    const addons = [
        { productId: 51655426113720, quantity: 1 }, // Damage Protection
        { productId: 51518960795832, quantity: 1 }, // Loss Protection
        { productId: 51454960795832, quantity: 1 }  // Theft Protection
    ];
    const mainProductId = 8670841831649; // Variant ID of the main product

    // ✅ Utility: Get current cart items
    function getCartContents() {
        return fetch('/cart.js')
            .then(response => response.json())
            .then(cart => cart.items)
            .catch(error => {
                console.error('Error fetching cart contents:', error);
                return [];
            });
    }

    // ✅ Utility: Add product to cart
    function addProductToCart(productId, quantity) {
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: productId, quantity })
        })
        .then(response => {
            if (!response.ok) {
                return response.text().then(text => { throw new Error(text); });
            }
            return response.json();
        })
        .then(data => console.log(`✅ Added product ${productId} to cart.`))
        .catch(error => console.error('❌ Error adding product:', error));
    }

    // ✅ Utility: Remove product from cart
    function removeProductFromCart(productId) {
        return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: productId, quantity: 0 })
        })
        .then(response => response.json())
        .then(data => console.log(`❌ Removed product ${productId} from cart.`))
        .catch(error => console.error('❌ Error removing product:', error));
    }

    // ✅ Add missing add-ons only
    function addAddonsIfNotInCart() {
        getCartContents().then(cartItems => {
            const cartItemIds = cartItems.map(item => item.id);
            console.log("🛒 Cart contains:", cartItemIds);

            let sequence = Promise.resolve();

            addons.forEach(addon => {
                if (!cartItemIds.includes(addon.productId)) {
                    console.log(`➕ Adding addon ${addon.productId}...`);
                    sequence = sequence.then(() => addProductToCart(addon.productId, addon.quantity));
                } else {
                    console.log(`✅ Addon ${addon.productId} already in cart.`);
                }
            });

            jQuery("#halo-cart-sidebar .halo-sidebar-wrapper").addClass("load-data");

            sequence.then(() => {
                jQuery("#halo-cart-sidebar .halo-sidebar-wrapper").load("/cart?view=ajax_side_cart", function () {
                    console.log('✅ All add-ons added. Cart refreshed.');
                    jQuery(".previewCart").css({ "overflow-y": "auto", "overflow-x": "hidden" });
                });
            });
        });
    }

    // ✅ Remove add-ons ONLY IF main product is not in cart
    function checkCartAndRemoveAddons() {
        getCartContents().then(cartItems => {
            const cartItemIds = cartItems.map(item => item.id);
            const mainProductInCart = cartItemIds.includes(mainProductId);
            const addonIds = addons.map(a => a.productId);
            const addonCountInCart = cartItems.filter(item => addonIds.includes(item.id)).length;

            if (!mainProductInCart && addonCountInCart > 0) {
                console.log("⚠️ Main product removed. Removing add-ons...");
                addons.forEach(addon => {
                    removeProductFromCart(addon.productId);
                });
            } else {
                console.log("✅ Main product in cart or no addons to remove.");
            }
        });
    }

    // ✅ Add to Cart Button - Trigger addon logic slightly after click
    jQuery(document).on('click', '.custom-product', function () {
        // Delay ensures main product has time to be added
        setTimeout(() => {
            addAddonsIfNotInCart();
        }, 1000);
    });

    // ✅ Cart item remove button - checks if main is gone, remove addons
    jQuery(document).on('click', '.previewCartItem-remove', function () {
        setTimeout(() => {
            checkCartAndRemoveAddons();
        }, 500);
    });
});
